import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostErinnerungCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostErinnerungCommandService],
  exports: []
})
export class PostErinnerungCommandServiceModule { }
